'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropertySource = undefined;

var _createProperty = require('ui-addon-upgrades/_core/common/data/upgradeData/transformers/createProperty');

var _sources = require('ui-addon-upgrades/_core/common/data/upgradeData/properties/sources');

var PROPERTY_KEY = 'source';

/**
 * @param {Object} upgradeData
 * @param {String} upgradeSource
 * @return {Object}
 */

var getPropertySource = exports.getPropertySource = function getPropertySource(_ref, upgradeSource) {
  var app = _ref.app,
      screen = _ref.screen,
      uniqueId = _ref.uniqueId;

  var propertyValue = app + '-' + screen + '-' + _sources.sources[upgradeSource] + '-' + uniqueId;

  return (0, _createProperty.createProperty)(PROPERTY_KEY, propertyValue);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/data/upgradeData/transformers/getPropertySource.js
// module id = 446
// module chunks = 3 4 5